import { downloadAsset, helperCreateObjectUrl } from "~/solidJs/shared/helpers";
import { initAudioViewerHoverMenu } from "~/solidJs/widgets/HoverFeatureMenu";
import Viewer from "../viewer";

export default class AudioViewer extends Viewer {
	static type = "audio";
	static supportedExtensions = ["mp3", "wav", "ogg"];

	constructor(asset, socketsOutput = null, socketName = null) {
		super(asset, socketsOutput, socketName);

		// Initialize new hover feature menu
		if (socketsOutput && socketName) {
			this.hoverMenuCleanup = initAudioViewerHoverMenu(this, socketsOutput, socketName);
		}
	}

	handleDownload() {
		if (this.asset) {
			downloadAsset(this.asset);
		}
	}

	loadAsync() {
		const url = helperCreateObjectUrl(this.asset);
		this.dom.content = document.createElement("div");
		this.dom.content.style.width = "100%";
		this.dom.content.style.height = "100%";
		this.dom.content.innerHTML = `
            <audio controls controlsList="nodownload">
                <source src="${url}">
                Your browser does not support the audio tag.
            </audio>
        `;
		this.domElement().prepend(this.dom.content);
	}

	reloadAssetAsync(asset) {
		this.asset = asset;
		const url = helperCreateObjectUrl(this.asset);
		this.dom.content.innerHTML = `
            <audio controls>
                <source src="${url}">
                Your browser does not support the audio tag.
            </audio>
        `;
	}
}
